"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toAttributeMap = exports.ActionGenerator = void 0;

var SerializationError_1 = __importDefault(require("../Errors/SerializationError"));
/* tslint:disable:variable-name */


var ActionGenerator = /*#__PURE__*/function () {
  function ActionGenerator(contract) {
    _classCallCheck(this, ActionGenerator);

    this.contract = contract;
  }

  _createClass(ActionGenerator, [{
    key: "acceptoffer",
    value: function () {
      var _acceptoffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(authorization, offer_id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this._pack(authorization, 'acceptoffer', {
                  offer_id: offer_id
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function acceptoffer(_x, _x2) {
        return _acceptoffer.apply(this, arguments);
      }

      return acceptoffer;
    }()
  }, {
    key: "addcolauth",
    value: function () {
      var _addcolauth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authorization, collection_name, account_to_add) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this._pack(authorization, 'addcolauth', {
                  collection_name: collection_name,
                  account_to_add: account_to_add
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function addcolauth(_x3, _x4, _x5) {
        return _addcolauth.apply(this, arguments);
      }

      return addcolauth;
    }()
  }, {
    key: "addconftoken",
    value: function () {
      var _addconftoken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(authorization, token_contract, token_symbol) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this._pack(authorization, 'addconftoken', {
                  token_contract: token_contract,
                  token_symbol: token_symbol
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addconftoken(_x6, _x7, _x8) {
        return _addconftoken.apply(this, arguments);
      }

      return addconftoken;
    }()
  }, {
    key: "addnotifyacc",
    value: function () {
      var _addnotifyacc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(authorization, collection_name, account_to_add) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this._pack(authorization, 'addnotifyacc', {
                  collection_name: collection_name,
                  account_to_add: account_to_add
                }));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addnotifyacc(_x9, _x10, _x11) {
        return _addnotifyacc.apply(this, arguments);
      }

      return addnotifyacc;
    }()
  }, {
    key: "announcedepo",
    value: function () {
      var _announcedepo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(authorization, owner, symbol_to_announce) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this._pack(authorization, 'announcedepo', {
                  owner: owner,
                  symbol_to_announce: symbol_to_announce
                }));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function announcedepo(_x12, _x13, _x14) {
        return _announcedepo.apply(this, arguments);
      }

      return announcedepo;
    }()
  }, {
    key: "backasset",
    value: function () {
      var _backasset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(authorization, payer, asset_owner, asset_id, token_to_back) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this._pack(authorization, 'backasset', {
                  payer: payer,
                  asset_owner: asset_owner,
                  asset_id: asset_id,
                  token_to_back: token_to_back
                }));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function backasset(_x15, _x16, _x17, _x18, _x19) {
        return _backasset.apply(this, arguments);
      }

      return backasset;
    }()
  }, {
    key: "burnasset",
    value: function () {
      var _burnasset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(authorization, asset_owner, asset_id) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this._pack(authorization, 'burnasset', {
                  asset_owner: asset_owner,
                  asset_id: asset_id
                }));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function burnasset(_x20, _x21, _x22) {
        return _burnasset.apply(this, arguments);
      }

      return burnasset;
    }()
  }, {
    key: "canceloffer",
    value: function () {
      var _canceloffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(authorization, offer_id) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this._pack(authorization, 'canceloffer', {
                  offer_id: offer_id
                }));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function canceloffer(_x23, _x24) {
        return _canceloffer.apply(this, arguments);
      }

      return canceloffer;
    }()
  }, {
    key: "createcol",
    value: function () {
      var _createcol = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(authorization, author, collection_name, allow_notify, authorized_accounts, notify_accounts, market_fee, data) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this._pack(authorization, 'createcol', {
                  author: author,
                  collection_name: collection_name,
                  allow_notify: allow_notify,
                  authorized_accounts: authorized_accounts,
                  notify_accounts: notify_accounts,
                  market_fee: market_fee,
                  data: data
                }));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function createcol(_x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32) {
        return _createcol.apply(this, arguments);
      }

      return createcol;
    }()
  }, {
    key: "createoffer",
    value: function () {
      var _createoffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(authorization, sender, recipient, sender_asset_ids, recipient_asset_ids, memo) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this._pack(authorization, 'createoffer', {
                  sender: sender,
                  recipient: recipient,
                  sender_asset_ids: sender_asset_ids,
                  recipient_asset_ids: recipient_asset_ids,
                  memo: memo
                }));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function createoffer(_x33, _x34, _x35, _x36, _x37, _x38) {
        return _createoffer.apply(this, arguments);
      }

      return createoffer;
    }()
  }, {
    key: "createtempl",
    value: function () {
      var _createtempl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(authorization, authorized_creator, collection_name, schema_name, transferable, burnable, max_supply, immutable_data) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", this._pack(authorization, 'createtempl', {
                  authorized_creator: authorized_creator,
                  collection_name: collection_name,
                  schema_name: schema_name,
                  transferable: transferable,
                  burnable: burnable,
                  max_supply: max_supply,
                  immutable_data: immutable_data
                }));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function createtempl(_x39, _x40, _x41, _x42, _x43, _x44, _x45, _x46) {
        return _createtempl.apply(this, arguments);
      }

      return createtempl;
    }()
  }, {
    key: "createschema",
    value: function () {
      var _createschema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(authorization, authorized_creator, collection_name, schema_name, schema_format) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this._pack(authorization, 'createschema', {
                  authorized_creator: authorized_creator,
                  collection_name: collection_name,
                  schema_name: schema_name,
                  schema_format: schema_format
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function createschema(_x47, _x48, _x49, _x50, _x51) {
        return _createschema.apply(this, arguments);
      }

      return createschema;
    }()
  }, {
    key: "declineoffer",
    value: function () {
      var _declineoffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(authorization, offer_id) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this._pack(authorization, 'declineoffer', {
                  offer_id: offer_id
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function declineoffer(_x52, _x53) {
        return _declineoffer.apply(this, arguments);
      }

      return declineoffer;
    }()
  }, {
    key: "extendschema",
    value: function () {
      var _extendschema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(authorization, authorized_editor, collection_name, schema_name, schema_format_extension) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", this._pack(authorization, 'extendschema', {
                  authorized_editor: authorized_editor,
                  collection_name: collection_name,
                  schema_name: schema_name,
                  schema_format_extension: schema_format_extension
                }));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function extendschema(_x54, _x55, _x56, _x57, _x58) {
        return _extendschema.apply(this, arguments);
      }

      return extendschema;
    }()
  }, {
    key: "forbidnotify",
    value: function () {
      var _forbidnotify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(authorization, collection_name) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this._pack(authorization, 'forbidnotify', {
                  collection_name: collection_name
                }));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function forbidnotify(_x59, _x60) {
        return _forbidnotify.apply(this, arguments);
      }

      return forbidnotify;
    }()
  }, {
    key: "locktemplate",
    value: function () {
      var _locktemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(authorization, authorized_editor, collection_name, template_id) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this._pack(authorization, 'locktemplate', {
                  authorized_editor: authorized_editor,
                  collection_name: collection_name,
                  template_id: template_id
                }));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function locktemplate(_x61, _x62, _x63, _x64) {
        return _locktemplate.apply(this, arguments);
      }

      return locktemplate;
    }()
  }, {
    key: "mintasset",
    value: function () {
      var _mintasset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(authorization, authorized_minter, collection_name, schema_name, template_id, new_asset_owner, immutable_data, mutable_data, tokens_to_back) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this._pack(authorization, 'mintasset', {
                  authorized_minter: authorized_minter,
                  collection_name: collection_name,
                  schema_name: schema_name,
                  template_id: template_id,
                  new_asset_owner: new_asset_owner,
                  immutable_data: immutable_data,
                  mutable_data: mutable_data,
                  tokens_to_back: tokens_to_back
                }));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function mintasset(_x65, _x66, _x67, _x68, _x69, _x70, _x71, _x72, _x73) {
        return _mintasset.apply(this, arguments);
      }

      return mintasset;
    }()
  }, {
    key: "payofferram",
    value: function () {
      var _payofferram = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(authorization, payer, offer_id) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this._pack(authorization, 'payofferram', {
                  payer: payer,
                  offer_id: offer_id
                }));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function payofferram(_x74, _x75, _x76) {
        return _payofferram.apply(this, arguments);
      }

      return payofferram;
    }()
  }, {
    key: "remcolauth",
    value: function () {
      var _remcolauth = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(authorization, collection_name, account_to_remove) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this._pack(authorization, 'remcolauth', {
                  collection_name: collection_name,
                  account_to_remove: account_to_remove
                }));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function remcolauth(_x77, _x78, _x79) {
        return _remcolauth.apply(this, arguments);
      }

      return remcolauth;
    }()
  }, {
    key: "remnotifyacc",
    value: function () {
      var _remnotifyacc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(authorization, collection_name, account_to_remove) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this._pack(authorization, 'remnotifyacc', {
                  collection_name: collection_name,
                  account_to_remove: account_to_remove
                }));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function remnotifyacc(_x80, _x81, _x82) {
        return _remnotifyacc.apply(this, arguments);
      }

      return remnotifyacc;
    }()
  }, {
    key: "setassetdata",
    value: function () {
      var _setassetdata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(authorization, authorized_editor, asset_owner, asset_id, new_mutable_data) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this._pack(authorization, 'setassetdata', {
                  authorized_editor: authorized_editor,
                  asset_owner: asset_owner,
                  asset_id: asset_id,
                  new_mutable_data: new_mutable_data
                }));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function setassetdata(_x83, _x84, _x85, _x86, _x87) {
        return _setassetdata.apply(this, arguments);
      }

      return setassetdata;
    }()
  }, {
    key: "setcoldata",
    value: function () {
      var _setcoldata = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(authorization, collection_name, data) {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this._pack(authorization, 'setcoldata', {
                  collection_name: collection_name,
                  data: data
                }));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function setcoldata(_x88, _x89, _x90) {
        return _setcoldata.apply(this, arguments);
      }

      return setcoldata;
    }()
  }, {
    key: "setmarketfee",
    value: function () {
      var _setmarketfee = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(authorization, collection_name, market_fee) {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this._pack(authorization, 'setmarketfee', {
                  collection_name: collection_name,
                  market_fee: market_fee
                }));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function setmarketfee(_x91, _x92, _x93) {
        return _setmarketfee.apply(this, arguments);
      }

      return setmarketfee;
    }()
  }, {
    key: "transfer",
    value: function () {
      var _transfer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(authorization, account_from, account_to, asset_ids, memo) {
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this._pack(authorization, 'transfer', {
                  from: account_from,
                  to: account_to,
                  asset_ids: asset_ids,
                  memo: memo
                }));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function transfer(_x94, _x95, _x96, _x97, _x98) {
        return _transfer.apply(this, arguments);
      }

      return transfer;
    }()
  }, {
    key: "withdraw",
    value: function () {
      var _withdraw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(authorization, owner, token_to_withdraw) {
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this._pack(authorization, 'withdraw', {
                  owner: owner,
                  token_to_withdraw: token_to_withdraw
                }));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function withdraw(_x99, _x100, _x101) {
        return _withdraw.apply(this, arguments);
      }

      return withdraw;
    }()
  }, {
    key: "_pack",
    value: function _pack(authorization, name, data) {
      return [{
        account: this.contract,
        name: name,
        authorization: authorization,
        data: data
      }];
    }
  }]);

  return ActionGenerator;
}();

exports.ActionGenerator = ActionGenerator;

function toAttributeMap(obj, schema) {
  var types = {};
  var result = [];

  var _iterator = _createForOfIteratorHelper(schema),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      types[row.name] = row.type;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var keys = Object.keys(obj);

  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
    var key = _keys[_i];

    if (typeof types[key] !== 'undefined') {
      throw new SerializationError_1.default('field not defined in schema');
    }

    result.push({
      key: key,
      value: [types[key], obj[key]]
    });
  }

  return result;
}

exports.toAttributeMap = toAttributeMap;